import {
  Breadcrumbs,
  Container,
  Divider,
  Theme,
  Typography,
} from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import React from 'react'
import { CategoryProductList } from '../DesktopElements/CategoryPageElements'

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      h1: {
        padding: theme.spacing(3, 0),
        textTransform: 'capitalize',
      },
      divider: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
      capitalize: {
        textTransform: 'capitalize',
      },
    }),
  { name: 'MuiCategoryPageComponent' },
)

const StylePage = ({
  permalink,
  styleName,
  styleDescription,
  staticData,
  productsCount,
  productsMinMaxPriceStatic,
  productsMinMaxDimensions,
  numberOfPages,
  pageNumber,
}) => {
  const classes = useStyles() as any
  const { t } = useTranslation(['common'])

  const styleSlug = t('style-slug')

  return (
    <>
      <Container maxWidth="xl">
        <Breadcrumbs aria-label="breadcrumb" style={{ padding: '1rem 0' }}>
          <Link prefetch={false} href="/">
            <Typography
              variant="caption"
              component="a"
              className={classes.capitalize}
            >
              {t('home-bread-crumb')}
            </Typography>
          </Link>
          <Typography variant="caption" className={classes.capitalize}>
            {styleName}
          </Typography>
        </Breadcrumbs>
        <Typography
          component="h1"
          variant="h3"
          align="center"
          gutterBottom
          className={classes.h1}
        >{`${styleName}`}</Typography>

        <Divider className={classes.divider} />

        <CategoryProductList
          staticData={staticData}
          productsCount={productsCount}
          permalink={permalink}
          numberOfPages={numberOfPages}
          pageNumber={pageNumber}
          pageSlug={styleSlug}
          fullPermalink={permalink}
        />

        <Divider className={classes.divider} />

        <Typography
          component="h3"
          variant="body1"
          align="center"
          gutterBottom
        >{`${styleDescription}`}</Typography>
      </Container>
    </>
  )
}

export default StylePage
